
























































































import CompanySheet from "@/components/company/CompanySheet.vue";
import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IClearance } from "@/models/clearance.entity";
import { Company, ICompany } from "@/models/company.entity";
import { Reference } from "@/models/reference.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";

export enum ReportClearanceUpdateStatusSteps {
  FORM = "form",
  SEND_MAIL = "sendMail"
}

@Component({
  components: { PreselectTemplateCard, CompanySheet, MNoContent },
  filters: {}
})
export default class ReportClearanceUpdateStatusDialog extends mixins(PermissionMixin) implements IDialog {
  readonly ReportClearanceUpdateStatusSteps = ReportClearanceUpdateStatusSteps;
  readonly PreselectTemplateKeysEnum = PreselectTemplateKeysEnum;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  @Prop({ default: false }) value!: boolean;
  @Prop() clearance!: IClearance;

  dialog: boolean = this.value;

  @Watch("value")
  onValueChange(val: boolean) {
    if (val) {
      const companyId = this.clearance?.seller?.ref?.refId;

      if (!companyId) {
        this.sellerCompany = null;
      } else if (this.report.workshopCompanyId === companyId) {
        this.sellerCompany = this.report.workShopCompany;
      } else if (this.report.damageBrokerCompanyId === companyId) {
        this.sellerCompany = this.report.damageBrokerCompany;
      } else {
        this.sellerCompany = new Company({ id: companyId, partnerId: this.partner.id });
        this.sellerCompany.fetch();
        this.sellerCompany.fetchSharedContent(this.report.id);
      }
    }
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  step = ReportClearanceUpdateStatusSteps.FORM;

  sharedContent: ISharedContent = new SharedContent({ partnerId: this.partner.id });

  requestsLoading = false;

  sellerCompany: ICompany | null = null;

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get attachmentFileFilters() {
    return this.report?.refFilter || [];
  }

  get vehicle() {
    return PartnerModule.report.vehicle;
  }

  get context() {
    return {
      clearance: this.clearance,
      sharedContent: this.sharedContent,
      partner: this.partner,
      report: this.report,
      vehicle: this.vehicle,
      url: { sharing: this.sharedContent.url }
    };
  }

  get validForm() {
    if (!this.sellerCompany?.id || this.sellerCompany.loading || this.sellerCompany.isSharedContentLoading) {
      return false;
    }

    return true;
  }

  get myUserId() {
    return UserModule.userId;
  }

  async createRequests() {
    this.requestsLoading = true;
    try {
      await this.clearance.updatePartial({
        status: RequestStatusEnum.ACCEPTED
      });

      if (!this.sellerCompany || !this.sellerCompany.id) {
        throw new Error("Seller company is not defined");
      }

      if (this.sellerCompany?.activeSharedContent) {
        this.sellerCompany?.activeSharedContent.addRef(
          new Reference({ refId: this.clearance.id, refType: ResourceEnum.CLEARANCE }),
          true
        );
        this.sharedContent = this.sellerCompany.activeSharedContent;
      } else {
        this.sharedContent.reportId = this.report.id;
        if (this.sellerCompany.id) {
          this.sharedContent.companyIds = [this.sellerCompany.id];
        }

        this.sharedContent.refs = [
          ...this.clearance.refs,
          new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT })
        ];
        if (this.clearance.id) {
          this.sharedContent.refs.unshift(new Reference({ refId: this.clearance.id, refType: ResourceEnum.CLEARANCE }));
        } else {
          throw new Error("Clearance ID is not defined");
        }

        await this.sharedContent.create();
        if (this.sellerCompany) {
          this.sellerCompany.activeSharedContent = this.sharedContent;
          this.sellerCompany.sharedContent.push(this.sharedContent);
        }
      }
      if (this.sharedContent.id) {
        this.clearance.sharedContent.push(this.sharedContent);
      }

      this.$emit("create:sharedContent", this.sharedContent);
    } catch (e) {
      handleError(e);
    }
    this.requestsLoading = false;
    return {
      clearance: this.clearance,
      sharedContent: this.sharedContent
    };
  }

  async createAndClose() {
    const request = await this.createRequests();
    request.sharedContent.copyUrl();
    this.close();
  }

  async createReportAndSend() {
    await this.createRequests();
    this.step = ReportClearanceUpdateStatusSteps.SEND_MAIL;
  }

  async sendMail() {
    await this.templateCard?.send();
    //TODO: change backend and adds isApproved to clearance that we can update status here one more time
    //await this.clearance.updatePartial({
    //  status: RequestStatusEnum.REQUESTED
    //});
    this.close();
  }

  async close() {
    this.dialog = false;
    this.reset();
  }

  open() {
    this.reset();
    this.dialog = true;
  }

  reset() {
    this.step = ReportClearanceUpdateStatusSteps.FORM;
    this.sharedContent = new SharedContent({ partnerId: this.partner.id });
  }
}
